import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { environment } from './../environments/environment';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headersRequest = request.clone({
      setHeaders: {
        'Content-Type': environment.headers.contentType
      }
    });

    return next.handle(headersRequest);
  }
}
